__webpack_require__.p = "https://phish.in/packs/";